export default __webpack_public_path__ + "static/media/javascript-interview.d04149e1.png";